import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ReactSelect from "../../../../app/modules/UI/ReactSelect";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
const initialValues = {
  structureId: "",
  name: "",
  structureBranch: "",
};

export default function Create(props) {
  const { show, onHide, onLocalStructures, structureId } = props;
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [chooseStructureIdOption, setChooseStructureIdOption] = useState([]);

  const [department, setDepartment] = useState();
  const [directorate, setDirectorate] = useState();
  const [branch, setBranch] = useState();
  const [division, setDivision] = useState();

  const [chooseDepartmentOption, setChooseDepartmentOption] = useState([]);
  const [chooseDirectorateOption, setChooseDirectorateOption] = useState([]);
  const [chooseBranchOption, setChooseBranchOption] = useState([]);
  const [chooseDivisionOption, setChooseDivisionOption] = useState([]);

  const CreateSchema = Yup.object().shape({
    name: Yup.string().required("Ad tələb olunur."),
    structureBranch: Yup.string().required("Struktur tipi tələb olunur."),
    structureId: Yup.string().when("structureBranch", {
      is: (value) => value && value !== "COMPANY",
      then: Yup.string().required("Struktur tələb olunur"),
    }),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const onPostGroup = (values, resetForm, setSubmitting) => {
    setIsLoading(true);

    const group = {
      name: values.name,
      structureId: values.structureId ? values.structureId : 0,
      structureBranch: values.structureBranch,
    };

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}structure`,
      data: group,
    })
      .then((res) => {
        onLocalStructures();
        setSubmitting(false);
        resetForm();
        onHide(false);
        setIsLoading(false);
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostGroup(values, resetForm, setSubmitting);
    },
  });

  const resetForm = () => {
    onHide();
    formik.resetForm();
  };

  useEffect(() => {
    setIsError("");
  }, [show]);

  function handleChangeStructure(value) {
    setChooseStructureIdOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newDepartmentItem = displayTypes.filter((obj) => {
          return obj.type == "DEPARTMENT";
        });
        const newDirectorateItem = displayTypes.filter((obj) => {
          return obj.type === "DIRECTORATE";
        });
        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });

        setDepartment(newDepartmentItem);
        setDirectorate(newDirectorateItem);
        setBranch(newBranchItem);
        setDivision(newDivisionItem);

        setChooseDirectorateOption(null);
        setChooseBranchOption(null);
        setChooseDivisionOption(null);
        setChooseDepartmentOption(null);
      });
  }

  const handleChangeDirectorateNames = (value) => {
    setChooseDirectorateOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newDepartmentItem = displayTypes.filter((obj) => {
          return obj.type === "DEPARTMENT";
        });
        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });

        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setDepartment(newDepartmentItem);
        setChooseDepartmentOption(null);
        setChooseBranchOption(null);
        setChooseDivisionOption(null);
      });
  };

  const handleChangeDepartmentNames = (value) => {
    setChooseDepartmentOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });

        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setChooseBranchOption(null);
        setChooseDivisionOption(null);
      });
  };

  const handleChangeBranchNames = (value) => {
    setChooseBranchOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });

        setDivision(newDivisionItem);

        setChooseDivisionOption(null);
      });
  };

  const handleChangeDivisionNames = (value) => {
    setChooseDivisionOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");
  };

  return (
    <Modal
      size="xl"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Ad"
                    placeholder="Ad"
                    className="w-100"
                    error={getInputClasses("name")}
                    {...formik.getFieldProps("name")}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              </div>
              <div className=" col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <FormControl className="w-100">
                    <InputLabel htmlFor="structureBranch">
                      Struktur tipi
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "structureBranch",
                        id: "structureBranch",
                      }}
                      error={getInputClasses("structureBranch")}
                      {...formik.getFieldProps("structureBranch")}
                    >
                      <MenuItem value="COMPANY">Şirkət</MenuItem>
                      <MenuItem value="DIRECTORATE">Direktorluq</MenuItem>
                      <MenuItem value="DEPARTMENT">Departament</MenuItem>
                      <MenuItem value="BRANCH">Şöbə</MenuItem>
                      <MenuItem value="DIVISION">Bölmə</MenuItem>
                      <MenuItem value="STRUCTURE_TYPE">Struktur növü</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {formik.touched.structureBranch &&
                formik.errors.structureBranch ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.structureBranch}
                    </div>
                  </div>
                ) : null}
              </div>
              {formik.values.structureBranch === "DIRECTORATE" && (
                <div className="col-6 col-md-6 col-lg-6">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <input
                      type="text"
                      name="structureId"
                      hidden
                      {...formik.getFieldProps("structureId")}
                    />

                    <ReactSelect
                      suggestions={structureId}
                      handleChangeSingle={(value) =>
                        handleChangeStructure(value)
                      }
                      single={chooseStructureIdOption}
                      label="Şirkət  seçin"
                      placeholder="Şirkət seçin"
                      inputId="structureId"
                    />
                  </div>
                  {formik.touched.structureId && formik.errors.structureId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.structureId}
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
              {formik.values.structureBranch === "DEPARTMENT" && (
                <>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={structureId}
                        handleChangeSingle={(value) =>
                          handleChangeStructure(value)
                        }
                        single={chooseStructureIdOption}
                        label="Şirkət  seçin"
                        placeholder="Şirkət seçin"
                        inputId="structureId"
                      />
                    </div>
                    {formik.touched.structureId && formik.errors.structureId ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.structureId}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={directorate}
                        handleChangeSingle={(value) =>
                          handleChangeDirectorateNames(value)
                        }
                        single={chooseDirectorateOption}
                        label="Direktorluq  seçin"
                        placeholder="Direktorluq seçin"
                        inputId="structureId"
                      />
                    </div>
                  </div>
                </>
              )}
              {formik.values.structureBranch === "BRANCH" && (
                <>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={structureId}
                        handleChangeSingle={(value) =>
                          handleChangeStructure(value)
                        }
                        single={chooseStructureIdOption}
                        label="Şirkət  seçin"
                        placeholder="Şirkət seçin"
                        inputId="structureId"
                      />
                    </div>
                    {formik.touched.structureId && formik.errors.structureId ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.structureId}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={directorate}
                        handleChangeSingle={(value) =>
                          handleChangeDirectorateNames(value)
                        }
                        single={chooseDirectorateOption}
                        label="Direktorluq  seçin"
                        placeholder="Direktorluq seçin"
                        inputId="Directorate"
                      />
                    </div>
                  </div>

                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={department}
                        handleChangeSingle={(value) =>
                          handleChangeDepartmentNames(value)
                        }
                        single={chooseDepartmentOption}
                        label="Departament  seçin"
                        placeholder="Departament seçin"
                        inputId="department"
                      />
                    </div>
                  </div>
                </>
              )}
              {formik.values.structureBranch === "DIVISION" && (
                <>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={structureId}
                        handleChangeSingle={(value) =>
                          handleChangeStructure(value)
                        }
                        single={chooseStructureIdOption}
                        label="Şirkət  seçin"
                        placeholder="Şirkət seçin"
                        inputId="structureId"
                      />
                    </div>
                    {formik.touched.structureId && formik.errors.structureId ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.structureId}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={directorate}
                        handleChangeSingle={(value) =>
                          handleChangeDirectorateNames(value)
                        }
                        single={chooseDirectorateOption}
                        label="Direktorluq  seçin"
                        placeholder="Direktorluq seçin"
                        inputId="Directorate"
                      />
                    </div>
                  </div>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={department}
                        handleChangeSingle={(value) =>
                          handleChangeDepartmentNames(value)
                        }
                        single={chooseDepartmentOption}
                        label="Departament  seçin"
                        placeholder="Departament seçin"
                        inputId="department"
                      />
                    </div>
                  </div>

                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />
                      <ReactSelect
                        suggestions={branch}
                        handleChangeSingle={(value) =>
                          handleChangeBranchNames(value)
                        }
                        single={chooseBranchOption}
                        label="Şöbə  seçin"
                        placeholder="Şöbə seçin"
                        inputId="branch"
                      />
                    </div>
                  </div>
                </>
              )}
              {formik.values.structureBranch === "STRUCTURE_TYPE" && (
                <>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={structureId}
                        handleChangeSingle={(value) =>
                          handleChangeStructure(value)
                        }
                        single={chooseStructureIdOption}
                        label="Şirkət  seçin"
                        placeholder="Şirkət seçin"
                        inputId="structureId"
                      />
                    </div>
                    {formik.touched.structureId && formik.errors.structureId ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.structureId}
                        </div>
                      </div>
                    ) : null}
                  </div>

                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={directorate}
                        handleChangeSingle={(value) =>
                          handleChangeDirectorateNames(value)
                        }
                        single={chooseDirectorateOption}
                        label="Direktorluq  seçin"
                        placeholder="Direktorluq seçin"
                        inputId="Directorate"
                      />
                    </div>
                  </div>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />

                      <ReactSelect
                        suggestions={department}
                        handleChangeSingle={(value) =>
                          handleChangeDepartmentNames(value)
                        }
                        single={chooseDepartmentOption}
                        label="Departament  seçin"
                        placeholder="Departament seçin"
                        inputId="department"
                      />
                    </div>
                  </div>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />
                      <ReactSelect
                        suggestions={branch}
                        handleChangeSingle={(value) =>
                          handleChangeBranchNames(value)
                        }
                        single={chooseBranchOption}
                        label="Şöbə  seçin"
                        placeholder="Şöbə seçin"
                        inputId="branch"
                      />
                    </div>
                  </div>
                  <div className="col-6 col-md-6 col-lg-6">
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input
                        type="text"
                        name="structureId"
                        hidden
                        {...formik.getFieldProps("structureId")}
                      />
                      <ReactSelect
                        suggestions={division}
                        handleChangeSingle={(value) =>
                          handleChangeDivisionNames(value)
                        }
                        single={chooseDivisionOption}
                        label="Bölmə seçin"
                        placeholder="Bölmə seçin"
                        inputId="division"
                      />
                    </div>
                  </div>
                </>
              )}

              {isError && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block MuiFormLabel-root Mui-error">
                    {isError}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
